import { type ComponentType, type ReactNode } from "react";
import CopyToClipboardModule from "react-copy-to-clipboard";
import { unwrapModuleDefault } from "./internal/interop";

type CopyToClipboardOptions = {
	debug?: boolean;
	message?: string;
	format?: string;
};

export type CopyToClipboardProps = {
	children?: ReactNode;
	text: string;
	onCopy?: (text: string, result: boolean) => void;
	options?: CopyToClipboardOptions;
};

const CopyToClipboardComponent = unwrapModuleDefault<ComponentType<CopyToClipboardProps>>(CopyToClipboardModule);

export default function CopyToClipboard(props: CopyToClipboardProps) {
	return <CopyToClipboardComponent {...props} />;
}
